// Pure helpers for the Website changes page.
export const SEV = { high: '#ef4444', medium: '#f59e0b', low: '#fb923c', info: '#60a5fa' };
export const KIND = {
  content: 'Content', title: 'Title', technology: 'Technology', version: 'Version', status: 'Status', redirect: 'Redirect',
  security_headers: 'Security headers', certificate: 'Certificate', down: 'Down', back_up: 'Back up'
};
export const hostOf = (url) => String(url || '').replace(/^https?:\/\//, '').replace(/\/$/, '');

// Sites with something new first, then the most recently changed.
export const ordered = (sites) => [...sites].sort((a, b) => (b.unseen || 0) - (a.unseen || 0) || String(b.last_changed_at || '').localeCompare(String(a.last_changed_at || '')) || a.url.localeCompare(b.url));

export function counters(sites, changes, now = new Date()) {
  const week = changes.filter((c) => now - new Date(c.created_at) <= 7 * 86400000);
  return {
    watched: sites.length,
    unseen: sites.reduce((n, s) => n + (s.unseen || 0), 0),
    week: week.length,
    weekSites: new Set(week.map((c) => c.watch)).size,
    attention: changes.filter((c) => !c.seen && (c.severity === 'medium' || c.severity === 'high')).length
  };
}

export const siteState = (s) => {
  if (!s.last_checked_at) return { label: 'Checking for the first time…', color: '#38bdf8' };
  if (!s.enabled) return { label: 'Paused', color: '#64748b' };
  if (s.failures >= 2 || !s.last_status) return { label: 'Not reachable', color: '#ef4444' };
  return { label: s.title || `Status ${s.last_status}`, color: s.last_status >= 400 ? '#f59e0b' : '#22c55e' };
};

export const FILTERS = [
  { id: 'all', label: 'All', test: () => true },
  { id: 'new', label: 'New', test: (c) => !c.seen },
  { id: 'content', label: 'Content', test: (c) => c.kind === 'content' || c.kind === 'title' },
  { id: 'versions', label: 'Versions', test: (c) => c.kind === 'version' || c.kind === 'technology' },
  { id: 'certificate', label: 'Certificates', test: (c) => c.kind === 'certificate' }
];

export const certText = (days) => (days == null ? '' : days < 0 ? 'Certificate expired' : `Certificate ${days} day${days === 1 ? '' : 's'}`);
export const certColor = (days) => (days == null ? '#64748b' : days < 7 ? '#ef4444' : days < 14 ? '#f59e0b' : '#22c55e');

// How much a person wants to hear about, in the words they see.
export const LEVELS = [
  { id: 'info', label: 'Everything', hint: 'Every change, even small ones' },
  { id: 'low', label: 'Most changes', hint: 'Everything except the smallest' },
  { id: 'medium', label: 'Important changes', hint: 'Medium and high only' },
  { id: 'high', label: 'Only serious changes', hint: 'High only, such as a site going down' }
];
export const levelText = (settings) => (!settings.email_enabled ? 'Email alerts are off.' : `Email me about: ${(LEVELS.find((l) => l.id === settings.min_severity) || LEVELS[1]).label.toLowerCase()}.`);
